import { render, staticRenderFns } from "./SupplierSolicitudeConfirmationModal.vue?vue&type=template&id=2508a399&scoped=true&lang=pug"
import script from "./SupplierSolicitudeConfirmationModal.vue?vue&type=script&lang=js"
export * from "./SupplierSolicitudeConfirmationModal.vue?vue&type=script&lang=js"
import style0 from "./SupplierSolicitudeConfirmationModal.vue?vue&type=style&index=0&id=2508a399&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2508a399",
  null
  
)

export default component.exports